'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _RoomViewStore = require('../../../stores/RoomViewStore');

var _RoomViewStore2 = _interopRequireDefault(_RoomViewStore);

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixTo = require('../../../matrix-to');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

function cancelQuoting() {
    _dispatcher2.default.dispatch({
        action: 'reply_to_event',
        event: null
    });
}

var ReplyPreview = function (_React$Component) {
    (0, _inherits3.default)(ReplyPreview, _React$Component);

    function ReplyPreview(props, context) {
        (0, _classCallCheck3.default)(this, ReplyPreview);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReplyPreview.__proto__ || (0, _getPrototypeOf2.default)(ReplyPreview)).call(this, props, context));

        _this.state = {
            event: null
        };

        _this._onRoomViewStoreUpdate = _this._onRoomViewStoreUpdate.bind(_this);

        _this._roomStoreToken = _RoomViewStore2.default.addListener(_this._onRoomViewStoreUpdate);
        _this._onRoomViewStoreUpdate();
        return _this;
    }

    (0, _createClass3.default)(ReplyPreview, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Remove RoomStore listener
            if (this._roomStoreToken) {
                this._roomStoreToken.remove();
            }
        }
    }, {
        key: '_onRoomViewStoreUpdate',
        value: function _onRoomViewStoreUpdate() {
            var event = _RoomViewStore2.default.getQuotingEvent();
            if (this.state.event !== event) {
                this.setState({ event: event });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.event) return null;

            var EventTile = _index2.default.getComponent('rooms.EventTile');

            return _react2.default.createElement(
                'div',
                { className: 'mx_ReplyPreview' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_ReplyPreview_section' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ReplyPreview_header mx_ReplyPreview_title' },
                        '💬 ' + (0, _languageHandler._t)('Replying')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ReplyPreview_header mx_ReplyPreview_cancel' },
                        _react2.default.createElement('img', { className: 'mx_filterFlipColor', src: require("../../../../res/img/cancel.svg"), width: '18', height: '18',
                            onClick: cancelQuoting })
                    ),
                    _react2.default.createElement('div', { className: 'mx_ReplyPreview_clear' }),
                    _react2.default.createElement(EventTile, { last: true,
                        tileShape: 'reply_preview',
                        mxEvent: this.state.event,
                        permalinkCreator: this.props.permalinkCreator,
                        isTwelveHour: _SettingsStore2.default.getValue("showTwelveHourTimestamps") })
                )
            );
        }
    }]);
    return ReplyPreview;
}(_react2.default.Component);

ReplyPreview.propTypes = {
    permalinkCreator: _propTypes2.default.instanceOf(_matrixTo.RoomPermalinkCreator).isRequired
};
exports.default = ReplyPreview;
module.exports = exports['default'];
//# sourceMappingURL=ReplyPreview.js.map